import { render, staticRenderFns } from "./LoRenamePreview.vue?vue&type=template&id=37a478b2&scoped=true"
import script from "./LoRenamePreview.vue?vue&type=script&lang=js"
export * from "./LoRenamePreview.vue?vue&type=script&lang=js"
import style0 from "./LoRenamePreview.vue?vue&type=style&index=0&id=37a478b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a478b2",
  null
  
)

export default component.exports